module.exports = __webpack_public_path__ + "img/trifold.dbc63249.svg";